// Per-user tenants list — drives the multi-tenant header dropdown (ADR-038 Q8).

import { apiFetch } from "./client";

export const tenantsApi = {
  myTenants: (token: string) => apiFetch<string[]>("/v1/me/tenants", token),
};
